import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Circles, Icon } from "@culturehq/components";
import client from "@culturehq/client";

import { t } from "app/utils";

const SEARCH_DELAY = 300;

const scrollToTop = () => window.scrollTo(0, 0);

class SearchBar extends Component {
  requestId = 0;

  timeout = 0;

  componentDidUpdate(prevProps) {
    const { searchQuery } = this.props;

    if (prevProps.searchQuery === searchQuery) {
      return;
    }

    if (this.timeout) {
      clearTimeout(this.timeout);
    }

    if (searchQuery) {
      this.timeout = setTimeout(() => this.performSearch(searchQuery), SEARCH_DELAY);
    }
  }

  handleSearchQueryClear = () => {
    const { onSearchQueryChange } = this.props;

    onSearchQueryChange("");
  };

  handleSearchQueryChange = event => {
    const { onSearchQueryChange } = this.props;

    onSearchQueryChange(event.target.value);
  };

  performSearch = async searchQuery => {
    const { onSearchResults } = this.props;

    this.requestId += 1;

    const { requestId } = this;
    const { results } = await client.search({ query: searchQuery });

    if (requestId !== this.requestId) {
      return;
    }

    onSearchResults(results);
  };

  render() {
    const { searchQuery } = this.props;

    return (
      <span className="chq-nav--search">
        <Link to="/" onClick={scrollToTop}>
          <Circles />
        </Link>
        <input
          type="text"
          value={searchQuery}
          onChange={this.handleSearchQueryChange}
          placeholder={t("Search...")}
        />
        {searchQuery.length > 0 && (
          <button type="button" onClick={this.handleSearchQueryClear}>
            <Icon icon="close" />
          </button>
        )}
      </span>
    );
  }
}

export default SearchBar;
